<template>
  <div class="LMSGpage">
    <div class="styleExplanation" style="padding: 15px;">
      {{ $t('iframe_page.form_explanation') }}
      <div class="styleAllowFormats" style="padding-top: 10px">
        {{ $t('iframe_page.allowed_formats') }}
      </div>
      <document-type-form
        v-if="showDocumentTypeForm('STATUS')"
        multipleDocs
        docType="STATUS"
        :idDocument="statusIdDocs"
        :subTitle="$t('iframe_page.docdesc.status')"
        :title="$t('iframe_page.doctypes.status')"
        :step="documents.filter(elem => elem.Type === 'STATUS')[0]"
        v-model="statusDocs">
        {{ $t('iframe_page.docinfo.status') }}
      </document-type-form>
      <hr>
      <document-type-form
        v-if="showDocumentTypeForm('RIB')"
        docType="RIB"
        :idDocument="ribIdDocs"
        :title="$t('iframe_page.doctypes.rib')"
        :subTitle="$t('iframe_page.docdesc.rib')"
        :step="documents.filter(elem => elem.Type === 'RIB')[0]"
        v-model="ribDocs">
        {{ $t('iframe_page.docinfo.rib') }}
      </document-type-form>
      <hr>
      <document-type-form
        v-if="showDocumentTypeForm('KBIS')"
        multipleDocs
        docType="KBIS"
        :idDocument="kbisIdDocs"
        :informations="$t('iframe_page.docinfo.kbis')"
        :title="$t('iframe_page.doctypes.kbis')"
        :subTitle="$t('iframe_page.docdesc.kbis')"
        :step="documents.filter(elem => elem.Type === 'KBIS')[0]"
        v-model="kbisDocs">
        {{ $t('iframe_page.docinfo.kbis') }}
      </document-type-form>
      <hr>
      <document-type-form
        v-if="showDocumentTypeForm('IDCARD')"
        multipleDocs
        docType="IDCARD"
        :idDocument="PIIdDocs"
        :title="$t('iframe_page.doctypes.id')"
        :subTitle="$t('iframe_page.docdesc.id')"
        :step="documents.filter(elem => elem.Type === 'IDCARD')[0]"
        v-model="PIDocs">
        {{ $t('iframe_page.docinfo.id_1') }}<br>
        <span class="pr-2"/>{{ $t('iframe_page.docinfo.id_2') }}<br>
        <span class="pr-2"/>{{ $t('iframe_page.docinfo.id_3') }}<br>
        <span class="pr-2"/>{{ $t('iframe_page.docinfo.id_4') }}<br>
        <span class="pr-2"/>{{ $t('iframe_page.docinfo.id_5') }}
      </document-type-form>
      <hr>
      <document-type-form
        v-if="showDocumentTypeForm('UBO')"
        docType="UBO"
        :title="$t('iframe_page.doctypes.shareholder')"
        :subTitle="$t('iframe_page.what_shareholder_declaration_is')"
        v-model="uboDocs">
        {{ $t('iframe_page.declaration_it_is_1')}} <b>{{$t('iframe_page.declaration_it_is_2')}}</b> <br/> {{ $t('iframe_page.declaration_it_is_3')}} {{$t('iframe_page.declaration_it_is_4') }}
      </document-type-form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import '../LMSGstyle.css'
import DocumentTypeForm from './DocumentTypeForm.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import Notifications from '@/components/common/notifications.vue'

export default {
  name: 'DocumentMainView',
  components: {
    'document-type-form': DocumentTypeForm,
    'form-accordion': FormAccordion,
    'notifications': Notifications
  },
  props: {
    documents: {
      type: Array,
      default: function () {
        return []
      }
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    isWaiting () {
      // A changer ensuite par l'id de status
      return this.statusLabel === 'En cours de vérification'
    }
  },
  watch: {
    documents: function (newDocs, oldDocs) {
      this.fillDocs(newDocs)
    }
  },
  created () {
    this.fillDocs(this.documents)
  },
  mounted () {
  //  this.$bus.$emit('sm-notif', { title: '', description: this.$t('iframe_page.valid_documents_1') + this.$t('iframe_page.valid_documents_2') })
  },
  data: function () {
    return {
      documentToShow: [],
      statusDocs: [],
      statusIdDocs: '',
      ribDocs: [],
      ribIdDocs: '',
      kbisDocs: [],
      kbisIdDocs: '',
      PIDocs: [],
      PIIdDocs: '',
      uboDocs: [],
      uboIdDocs: '',
      status: {
        TO_COMPLETE: [0],
        VERIFYING: [11, 13, 16, 30, 31],
        EXPIRED: [15],
        VALIDATED: [33],
        REFUSED: [12, 14, 32, 34]
      }
    }
  },
  methods: {
    fillDocs (docs) {
      let tmpStatusDocs = docs.filter(elem => elem.Type === 'STATUS')
      this.statusDocs = tmpStatusDocs.filter(elem => elem.Status !== 0)
      this.statusIdDocs = tmpStatusDocs.length ? tmpStatusDocs[0].IdDocument.toString() : ''
      if (tmpStatusDocs.length) {
        this.documentToShow.push('STATUS')
      }

      let tmpRibDocs = docs.filter(elem => elem.Type === 'RIB')
      this.ribDocs = tmpRibDocs.filter(elem => elem.Status !== 0)
      this.ribIdDocs = tmpRibDocs.length ? tmpRibDocs[0].IdDocument.toString() : ''
      if (tmpRibDocs.length) {
        this.documentToShow.push('RIB')
      }

      let tmpKbisDocs = docs.filter(elem => elem.Type === 'KBIS')
      this.kbisDocs = tmpKbisDocs.filter(elem => elem.Status !== 0)
      this.kbisIdDocs = tmpKbisDocs.length ? tmpKbisDocs[0].IdDocument.toString() : ''
      if (tmpKbisDocs.length) {
        this.documentToShow.push('KBIS')
      }

      let tmpPIDocs = docs.filter(elem => elem.Type === 'IDCARD')
      if (tmpPIDocs[0] && tmpPIDocs[0].documentName && Array.isArray(tmpPIDocs[0].documentName)) {
        let listNames = tmpPIDocs[0].documentName
        tmpPIDocs[0].Name = listNames[0]
        tmpPIDocs[0].Data = tmpPIDocs[0].documentData.split(';data:')[0]
        tmpPIDocs.push(_.cloneDeep(tmpPIDocs[0]))
        tmpPIDocs[1].Name = listNames[1]
        tmpPIDocs[1].Data = 'data:' + tmpPIDocs[1].documentData.split(';data:')[1]
      }
      this.PIDocs = tmpPIDocs.filter(elem => elem.Status !== 0)
      this.PIIdDocs = tmpPIDocs.length ? tmpPIDocs[0].IdDocument.toString() : ''
      if (tmpPIDocs.length) {
        this.documentToShow.push('IDCARD')
      }

      let tmpUboDocs = docs.filter(elem => elem.Type === 'PROOF_OF_ADDRESS')
      this.uboDocs = tmpUboDocs.filter(elem => elem.Status !== 0)
      this.uboIdDocs = tmpUboDocs.length ? tmpUboDocs[0].IdDocument.toString() : ''
      if (tmpUboDocs.length) {
        this.documentToShow.push('PROOF_OF_ADDRESS')
      }
    },
    showDocumentTypeForm (docType) {
      return this.documentToShow.includes(docType)
    }
  }
}
</script>
<style scoped>
/* Ajouts sur selectionBloc utiles uniquement sur ce component (pas sur Shareholder) */
.selectionBloc {
  margin-top: 15px;
  width: 100%;
}
.information_check {
  color: red;
}
.information_check_no {
  color: #49A0A2;
}
.btn-declare {
  background-color: black;
}
.styleExplanation {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #1B1918;
}
.styleAllowFormats {
  font-style: italic;
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  color: #1B1918;
}
</style>



// WEBPACK FOOTER //
// DocumentMainView.vue?2043b0cb